import { RouteRecordRaw } from 'vue-router';

const mainRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/HomeView.vue'),
    meta: {
      title: 'Home',
      requiresAuth: false,
    },
  },
  {
    path: '/betreibung',
    name: 'betreibung',
    component: () => import(/* webpackChunkName: "betreibung" */ '@/views/BetreibungView.vue'),
    meta: {
      title: 'Betreibung',
      requiresAuth: false,
    },
  },
  {
    path: '/tutorial',
    name: 'tutorial',
    component: () => import(/* webpackChunkName: "tutorial" */ '@/views/TutorialView.vue'),
    meta: {
      title: 'Tutorial',
      requiresAuth: false,
    },
  },
];

export default mainRoutes;